import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./lib/i18n";
import { setupAutoSync } from "./lib/syncManager";

// Fail fast with a readable message if the Supabase env is missing.
// Without this, createClient(undefined, undefined) throws deep in the
// SDK and the user just sees a white screen — impossible to diagnose
// from a production deploy. A misconfigured build now renders a clear
// hint about which env vars to set.
function renderConfigError(missing: string[]) {
  const root = document.getElementById("root");
  if (!root) return;
  root.innerHTML = `
    <div style="min-height:100vh;display:grid;place-items:center;font-family:system-ui,sans-serif;padding:24px;text-align:center;color:#1f2937;background:#f9fafb">
      <div style="max-width:480px">
        <h1 style="font-size:20px;font-weight:600;margin:0 0 8px">Configuratiefout · Configuration error</h1>
        <p style="margin:0 0 16px;color:#6b7280">
          De app kan niet starten omdat verplichte omgevingsvariabelen ontbreken.<br/>The app can't start because required environment variables are missing.
        </p>
        <code style="display:block;background:#111827;color:#f9fafb;padding:12px 16px;border-radius:8px;font-size:13px;text-align:left">
          ${missing.map((m) => `${m}=…`).join("<br/>")}
        </code>
        <p style="margin:16px 0 0;font-size:13px;color:#9ca3af">
          Zet deze in je deploy-omgeving (zie .env.example) en publiceer opnieuw.<br/>Set these in your deployment environment (see .env.example) and redeploy.
        </p>
      </div>
    </div>`;
}

const missingEnv = [
  ["VITE_SUPABASE_URL", import.meta.env.VITE_SUPABASE_URL],
  ["VITE_SUPABASE_PUBLISHABLE_KEY", import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY],
]
  .filter(([, v]) => !v)
  .map(([k]) => k as string);

if (missingEnv.length > 0) {
  renderConfigError(missingEnv);
} else {
  // Initialize auto-sync when app loads
  if (typeof window !== "undefined") {
    setupAutoSync();
  }

  createRoot(document.getElementById("root")!).render(<App />);
}
